import styled from 'styled-components';

export const SectionTitle = styled.caption`
  text-align: left;
  margin-bottom: 10px;
  margin-top: 15px;
  font-weight: 700;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 16px;
`;

export const Th = styled.th`
  background: #f1f3f9;
  text-align: left;
  font-weight: 700;
  padding: 10px;
`;

export const Td = styled.td`
  background: #f9fafd;
  padding: 12px 10px;
  border-top: 1px solid #eef1f7;
`;

export const EmptyState = styled.p`
  margin: 0 0 16px;
  color: #555;
`;

export const PhotosGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 16px;
  margin-bottom: 16px;
`;

export const PhotoItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const PhotoDescription = styled.p`
  margin: 0 0 8px;
  font-weight: 600;
  color: #2d3748;
`;

export const PhotoButton = styled.button`
  border: 0;
  background: transparent;
  padding: 0;
  cursor: pointer;

  :disabled {
    cursor: not-allowed;
  }
`;

export const PhotoHint = styled.p`
  margin: 8px 0 0;
  color: #555;
  font-size: 12px;
`;
